// The manager API's origin: VITE_API_URL at build time, else this origin.
export const API_ORIGIN: string = (import.meta.env.VITE_API_URL || window.location.origin).replace(/\/$/, "");
